import LayoutMaster from "../../components/layout/layout_master";
import Img from "react-cloudimage-responsive";
import Link from "next/link";
import { useState } from "react";
import getinfo from "lib/worker/api/getinfo";
import UboxRewardShow from "components/view/ubox_reward_show";
import topup_angpao, { TopupAngpaoResponse } from "lib/worker/api/topup_angpao";
import { alertWithMessage } from "components/modal/message_modal";
import Spinner from "components/view/loader";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";

interface Props {
  infomation: CheckWithPrefixResponse;
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

export default function UGameAngPow(props: Props) {
  const [topup, settopup] = useState<TopupAngpaoResponse>();
  const [animationa, setanimationa] = useState("checkin");
  const [animationb, setanimationb] = useState("checkin");
  const [animationc, setanimationc] = useState("checkin");
  const [animationimagea, setanimationimagea] = useState(
    "Ang-Pow-Card-SNAMBET2.png"
  );
  const [animationimageb, setanimationimageb] = useState(
    "Ang-Pow-Card-SNAMBET2.png"
  );
  const [animationimagec, setanimationimagec] = useState(
    "Ang-Pow-Card-SNAMBET2.png"
  );
  const [idx, setid] = useState(0);
  const [idxforloading, setidforloading] = useState(0);
  const [isloading, setisloading] = useState<boolean>(false);

  const bet = (id: number) => {
    if (idx != 0) {
      return;
    }

    setisloading(true);
    setidforloading(id);
    topup_angpao()
      .then((json) => {
        setid(id);
        settopup(json);
        shake(id);
        getinfo();
        return json;
      })
      .catch((error) => {
        alertWithMessage(error.response.data.message);
      })
      .finally(() => {
        setisloading(false);
      });
  };

  const shake = (id: number) => {
    switch (id) {
      case 1:
        setanimationa("shake");
        setTimeout(() => {
          setanimationimagea("Ang-Pow-Card-Open-SNAMBET2.png");
        }, 500);
        break;
      case 2:
        setanimationb("shake");
        setTimeout(() => {
          setanimationimageb("Ang-Pow-Card-Open-SNAMBET2.png");
        }, 500);
        break;
      case 3:
        setanimationc("shake");
        setTimeout(() => {
          setanimationimagec("Ang-Pow-Card-Open-SNAMBET2.png");
        }, 500);
        break;
    }
  };

  const displayCredit = () => {
    if (topup?.IsCredit) {
      return topup?.AmountA
        ? `ได้รับ ${topup?.AmountA.format(0, 0) ?? 0 ?? "..."}`
        : "...";
    } else {
      return "1,000 uDiamond";
    }
  };

  const showAward = (id: number) => {
    if (idx == 0 || isloading) {
      if (idxforloading == id) {
        if (isloading) {
          return (
            <div
              className="row center-row-content col"
              style={{
                position: "relative",
                marginTop: -35,
                marginBottom: 19,
              }}
            >
              <Spinner></Spinner>
            </div>
          );
        }
      }
      return "";
    }

    if (id == idx) {
      return (
        <label
          className="row center-row-content tranparent-bg-black"
          style={{
            marginTop: -35,
            position: "relative",
            fontWeight: 0.9,
            color: "#ffbe00",
          }}
        >
          {displayCredit()}
        </label>
      );
    } else {
      return (
        <label
          className="row center-row-content tranparent-bg-black"
          style={{
            marginTop: -35,
            position: "relative",
            fontWeight: 0.9,
          }}
        >
          {topup?.AmountB.format(0, 0) ?? 0 ?? "..."} ฿
        </label>
      );
    }
  };

  const showGlowAward = (id: number) => {
    if (idx == 0) {
      return "";
    }

    if (id == idx) {
      return "button-glowing";
    } else {
      return "";
    }
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "แจกอั่งเปาสูงสุด 1,000 บาท",
        description:
          "ผู้ใหญ่ใจดีแจกอั่งเปา ตั้งแต่ 20 จนถึง!! 1,000 บาทเพียงท่านฝากเงินครั่งแรกของวัน โดยกิจกรรมจะรีทุก จนถึง วันที่ 5 กุมภาพันธ์ 2565 เวลา 23.59 น.",
      }}
      information={props.infomation}
    >
      <div className="container" style={{ paddingTop: 20 }}>
        <h1 className="text-title text-center">
          <span>แจกอั่งเปาสำหรับสมาชิกที่ฝากเงินครั้งแรกของวัน</span>
        </h1>
        <div className="margin-top-20">
          <div className="row center-row-content">
            <div
              className={`col-4 col-sm-4 col-md-4 col-lg-2 ${animationa}`}
              onClick={() => {
                bet(1);
              }}
            >
              <Img
                ratio={0.9}
                className={showGlowAward(1)}
                src={animationimagea}
                alt="อั่งเปาลุ้นโชค"
              ></Img>
              {showAward(1)}
            </div>
            <div
              className={`col-4 col-sm-4 col-md-4 col-lg-2 ${animationb}`}
              onClick={() => {
                bet(2);
              }}
            >
              <Img
                ratio={0.9}
                className={showGlowAward(2)}
                src={animationimageb}
                alt="อั่งเปาลุ้นโชค"
              ></Img>
              {showAward(2)}
            </div>
            <div
              className={`col-4 col-sm-4 col-md-4 col-lg-2 ${animationc}`}
              onClick={() => {
                bet(3);
              }}
            >
              <Img
                ratio={0.9}
                className={showGlowAward(3)}
                src={animationimagec}
                alt="อั่งเปาลุ้นโชค"
              ></Img>
              {showAward(3)}
            </div>
          </div>
        </div>
        <div className="margin-top-40">
          <h2 className="text-title">ระยะเวลากิจกรรม</h2>
          <p>
            ระยะเวลาสิ้นสุดกิจกรรม: <span>5 กุมภาพันธ์ 2565</span>{" "}
          </p>
          <h4 className="text-title">วิธีการร่วมกิจกรรม</h4>
          <li>
            <span>ฝากเงินครั้งแรก</span> ของวันเพื่อรับสิทธ์เข้าร่วมกิจกรรม
          </li>
          <li>สามารถเข้าร่วมกิจกรรมได้ทุกวัน จนถึง วันสิ้นสุดกิจกรรม</li>
          <li>
            โดยกิจกรรมจะรีเซตทุกวัน เวลา 00.00 น. จนถึง วันที่{" "}
            <span>5 กุมภาพันธ์ 2565 เวลา 23.59 น.</span>
          </li>
          <li>
            เลือกเปิด <span>อั่งเปาลุ้นโชค</span> 1 ใน 3 อันที่ปรากฏ
            เพื่อลุ้นของรางวัล
          </li>
          <li>
            เมื่อท่าน <span>เปิดอั่งเปาลุ้นโชค</span> แล้วระบบจะเพิ่ม{" "}
            <span>uDiamond</span> ให้ท่านอัตโนมัติ
          </li>
          <li>
            ท่านสามารถนำ <span>uDiamond</span> ที่ได้รับไปแลกเป็นเงินได้ โดย{" "}
            <span>300 uDiamond</span> เท่ากับ <span>1 บาท</span>{" "}
            <Link href="/exchange">
              <a>
                <span style={{ textDecoration: "underline" }}>
                  คลิกเพื่อแลกเงิน
                </span>
              </a>
            </Link>
          </li>
          <li className="font-red">
            หากพบว่าลูกค้ามีเจตนาที่ไม่สุจริตเช่นการฝากเงิน
            แล้วถอนออกโดยไม่มีการเดิมพัน
            ทางเว็บขอยกเลิกสิทธิการรับรางวัลแก่สมาชิกที่มีเจตนาไม่สุจริต
          </li>
          <br></br>
          <h4>
            <span>ของรางวัลที่ได้จากการเปิดอั่งเปา</span>
          </h4>
          <ul>
            <li>
              ได้รับของรางวัลจากอั่งเป่า ตั้งแต่ <span>6,000 uDiamond</span>{" "}
              จนถึง!! <span>300,000 uDiamond </span>
            </li>
            <li>
              โดย <span>300 uDiamond</span> สามารถแลกได้ <span>1 บาท</span>{" "}
              <Link href="/exchange">
                <a>
                  <span style={{ textDecoration: "underline" }}>
                    คลิกเพื่อแลกเงิน
                  </span>
                </a>
              </Link>
            </li>
          </ul>
          <div className="margin-top-10">
            {AngPowRewards.map((value, index) => {
              return (
                <UboxRewardShow
                  key={index}
                  List={`ของรางวัลที่ - ${index + 1} `}
                  Name={`${value.name} : ${value.uname} `}
                  Pc={value.pc}
                ></UboxRewardShow>
              );
            })}
          </div>
        </div>
      </div>
    </LayoutMaster>
  );
}

const AngPowRewards = [
  {
    name: "20 บาท",
    uname: "6,000 uDiamond",
    pc: "26.32 %",
  },
  {
    name: "30 บาท",
    uname: "9,000 uDiamond",
    pc: "26.32 %",
  },
  {
    name: "50 บาท",
    uname: "15,000 uDiamond",
    pc: "26.32 %",
  },
  {
    name: "100 บาท",
    uname: "30,000 uDiamond",
    pc: "19.74 %",
  },
  {
    name: "200 บาท",
    uname: "60,000 uDiamond",
    pc: "1.05 %",
  },
  {
    name: "500 บาท",
    uname: "150,000 uDiamond",
    pc: "0.13 %",
  },
  {
    name: "1,000 บาท",
    uname: "300,000 uDiamond",
    pc: "0.09 %",
  },
];
